export * from '@primeuix/themes/material/confirmdialog';
export { default } from '@primeuix/themes/material/confirmdialog';
